import React from 'react';

const Trash: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    height="21"
    fill="none"
    viewBox="0 0 21 21"
    width="21"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M2.5 5H4.16667H17.5" stroke="#F04438" strokeLinecap="round"
      strokeLinejoin="round" strokeWidth="2.08" />
    <path d={`M6.66675 4.99935V3.33268C6.66675 2.89065 6.84234 2.46673 7.1549
      2.15417C7.46746 1.84161 7.89139 1.66602 8.33342 1.66602H11.6667C12.1088
      1.66602 12.5327 1.84161 12.8453 2.15417C13.1578 2.46673 13.3334 2.89065
      13.3334 3.33268V4.99935M15.8334 4.99935V16.666C15.8334 17.108 15.6578
      17.532 15.3453 17.8445C15.0327 18.1571 14.6088 18.3327 14.1667
      18.3327H5.83342C5.39139 18.3327 4.96746 18.1571 4.6549 17.8445C4.34234
      17.532 4.16675 17.108 4.16675 16.666V4.99935H15.8334Z`} stroke="#F04438" strokeLinecap="round"
      strokeLinejoin="round" strokeWidth="2.08" />
    <path d="M8.33325 9.16602V14.166" stroke="#F04438" strokeLinecap="round"
      strokeLinejoin="round" strokeWidth="2.08" />
    <path d="M11.6667 9.16602V14.166" stroke="#F04438" strokeLinecap="round"
      strokeLinejoin="round" strokeWidth="2.08" />
  </svg>
);

export default Trash;
